import { Directive, Input } from '@angular/core';
import { CdkColumnDef } from '@angular/cdk/table';

import { APP_TABLE_COLUMN_DEF } from './table.types';

/**
 * Column definition for the `app-table`.
 *
 * Adds an `app-column-{name}` CSS class to every cell rendered for the
 * column (alongside the `cdk-column-{name}` class added by the parent),
 * and exposes the column to nested directives via two injection tokens:
 *
 * - `CdkColumnDef`: kept so any CDK primitive that resolves the column
 *   from the injector tree continues to work.
 * - `APP_TABLE_COLUMN_DEF`: first-class token for the internalized stack
 *   (consumed by `app-sort-header` to infer the column id).
 */
@Directive({
  selector: '[appColumnDef]',
  // `sticky` comes from `mixinHasStickyInput` (CDK), which adds an
  // accessor on the prototype that Angular only exposes as an input
  // through this metadata array — using `@Input` on an inherited
  // accessor breaks the mixin.
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['sticky'],
  providers: [
    { provide: CdkColumnDef, useExisting: AppColumnDefDirective },
    { provide: APP_TABLE_COLUMN_DEF, useExisting: AppColumnDefDirective },
  ],
})
export class AppColumnDefDirective extends CdkColumnDef {
  @Input('appColumnDef')
  override get name(): string {
    return this._name;
  }
  override set name(value: string) {
    this._setNameInput(value);
  }

  protected override _updateColumnCssClassName(): void {
    super._updateColumnCssClassName();
    this._columnCssClassName.push(`app-column-${this.cssClassFriendlyName}`);
  }
}
